export const setPhoneNumber = (rawNumber: string) => {
  if (rawNumber[0] === '0') {
    return rawNumber.slice(1, rawNumber.length);
  }

  return rawNumber;
};
